import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  UsersService,
  CompanyService,
  ChangeProfilesService,
  SnackBarService,
  ChangeBranchesService,
} from 'app/services';
import { Profile, Company } from 'app/models';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';
import {
  ConfirmDeleteDialogComponent,
  AddUserToBranchDialogComponent,
} from '../../dialogs';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarType } from 'app/constants/Enums';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';
import { MatSort } from '@angular/material/sort';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-branches-table',
  templateUrl: './branches-table.component.html',
  styleUrls: ['./branches-table.component.scss'],
})
export class BranchesTableComponent implements OnInit, OnDestroy {
  public accountId: string;
  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private changeDet: ChangeDetectorRef,
    private _companyService: CompanyService,
    public _changeBranchesService: ChangeBranchesService,
    private _translateService: TranslateService,
    private _dialog: MatDialog,
    private _usersService: UsersService,
    private _changeProfilesService: ChangeProfilesService,
    private _snackbarService: SnackBarService,
    public _location: Location
  ) {}
  company: Company;
  error: string;
  users: Profile[] = [];
  userList: Profile[] = [];
  usersError: string;
  queryString: string;
  selectedUsers: Profile[];
  noRecordFound = false;
  public companyInitials: string;
  companyId: string;
  currentPageUsers: Profile[];
  private onDestroy$ = new Subject<void>();
  branch: any;
  public header: string;
  public status:string;
  companyBranchesDataSource = new MatTableDataSource([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort
  usersDataSource =  new MatTableDataSource([]);
  selection = new SelectionModel<Profile>(true, []);
  displayedColumns = [
    'select',
    'name',
    'email',
  ];
  message = 'No_Users_Found';

  ngOnInit() {
    this.companyId = this.route.snapshot.queryParamMap.get('companyId');
    this.status=this.route.snapshot.queryParamMap.get('companyStatus');
    this.accountId = this.route.snapshot.params['id'];
    this.subscribeTocompany();
    this.getUsers();
    this.usersDataSource
          .connect()
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((users) => {
            this.currentPageUsers = users;
          });
    this.changeDet.detectChanges();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  getUsersNotAssignedToBranch(): Profile[] {
    return this._companyService.users.filter(
      (user) => !user.branchAssignments.includes(this.accountId)
    );
  }

  subscribeTocompany(): void {
    this._companyService.company$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((company) => {
        if (company) {
          company.branches = this.parseLocation(company.branches);
          this.company = company;
          this._parseName();
          this.getBranch();
        } else {
          this.company = company;
          this.navigateToCompanyOverview();
        }
      });
    this._companyService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((error) => {
        this.error = error;
      });
  }

  isAllSelected(){
    const enabledRows = this.getSelectableRows();
    if(enabledRows.length == 0){
      return false;
    }
    
    return tableHelpers.isAllSelected(enabledRows, this.selection.selected);
  } 

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle (): void  {
    const enabledRows = this.getSelectableRows();
    return tableHelpers.masterToggle(enabledRows, this.selection);
  };

  isPartiallySelected (): boolean {
    return tableHelpers.isPartiallySelected(this.currentPageUsers, this.selection.selected);
  }

  getBranch(): void {
    const branch = this.company.branches.find(
      (companyBranch: Company) => companyBranch.accountId === this.accountId
    );
    if (branch) {
      this.setbranch(branch);
    } else {
      this._translateService
        .get('STANDARD_ERROR')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => (this.error = value));
    }
  }
  setbranch(branch) {
    this.branch = branch;
    this.header = `${branch.name}  ${branch.city}, ${branch.state} `;
  }
  private _parseName() {
    if (!this.company.name) {
      return;
    }
    this.companyInitials = `${this.company.name[0].toUpperCase()}${this.company.name[
      this.company.name.length - 1
    ].toUpperCase()}`;
  }

  parseLocation(companiesBranches) {
    companiesBranches.forEach((compBranch) => {
      compBranch.location = compBranch.city + ', ' + compBranch.state;
    });
    return companiesBranches;
  }

  monitorSearch(search: string) {
    this.queryString = search.trim();
    if (this.queryString.length >= Number(environment.minimumSearchLength)) {
      this.users = this.userList.filter((a) =>
        a['name'].toUpperCase().includes(this.queryString.toUpperCase().trim()) ||
        a['email'].toUpperCase().includes(this.queryString.toUpperCase().trim())
      );
      this.noRecordFound = this.users.length === 0;
    } else {
      this.users = this.userList;
      this.noRecordFound = false;
    }
    this.usersDataSource.data = this.users;
    setTimeout(() => {
      this.usersDataSource.paginator = this.paginator;
    }, 10);
  }

  parseName(users) {
    users.forEach((user) => {
      if(!user.name){
        user.name = `${user.firstName} ${user.lastName}`;
      }
    });
    this.changeDet.detectChanges();
    return users;
  }

  selectedRecords(event) {
    this.selectedUsers = event;
  }

  deleteUsers() {
    let deleteUsersMessage;
    this._translateService
      .get('COMPANY_DELETE_USERS.no_users_warning')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (deleteUsersMessage = value));
    let title;
    this._translateService
      .get('COMPANY_DETAILS_HEADER.remove_users')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (title = value));

    let info = '';
    this._translateService
      .get('SNACKBAR.info')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (info = value));

    if (this.selection.selected.length === 0) {
      this._snackbarService.showSnackbar(
        SnackbarType.info,
        info,
        deleteUsersMessage
      );
      return;
    } else if (
      this.selection.selected.findIndex((user) => user['isInvite']) !== -1
    ) {
      return;
    }

    let btnText = '';
    this._translateService
      .get('Remove')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (btnText = value));
    const dialog = this._dialog.open(ConfirmDeleteDialogComponent, {
      disableClose: true,
      autoFocus: false,
      data: {
        users: this.selection.selected,
        buttonText: btnText,
        title,
      },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.selection.selected.forEach((user) => {
          const branchIndex: number = user.branchAssignments.findIndex(
            (branch) => branch === this.accountId
          );
          if (branchIndex !== -1) {
            user.branchAssignments.splice(branchIndex, 1);
          }
        });
        if (this.selection.selected) {
          this._changeBranchesService.updateUserBranches(
            this.selection.selected,
            this.companyId
          );
        }
        this.selection.clear();
      }
    });
  }

  addUsers(): void {
    if (this.users) {
      // translate strings
      let addUsersMessage;
      this._translateService
        .get('BRANCH_USERS_DIALOG.all_users_assigned')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => (addUsersMessage = value));
      let title;
      this._translateService
        .get('APP_DETAILS.add_users_title')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => (title = value));
      this._changeProfilesService.clearUsers();
      const usersNotAssignedToBranch = this.getUsersNotAssignedToBranch();
      if (usersNotAssignedToBranch.length === 0) {
        let info = '';
        this._translateService
          .get('SNACKBAR.info')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((value) => (info = value));
        this._snackbarService.showSnackbar(SnackbarType.info, info, addUsersMessage);
        return;
      }

      const dialog = this._dialog.open(AddUserToBranchDialogComponent, {
        disableClose: true,
        autoFocus: true,
        data: {
          title,
          users: usersNotAssignedToBranch,
          branch: this.branch,
        },
      });

      dialog.afterClosed().subscribe((result) => {
        if (result) {
          const selectedUsers = this._changeProfilesService.getUsers();
          if (selectedUsers.length > 0) {
            this._changeBranchesService.updateUserBranches(
              selectedUsers,
              this.companyId
            );
          }
        }
      });
    }
  }

  getUsers() {
    combineLatest([this._companyService.branchesUsers$,
      this._usersService.companyUsers$]).pipe(takeUntil(this.onDestroy$)).subscribe(([branchesUsers, companyUsers]) => {
        const branchUsers = branchesUsers?.find((b) => b.branchId === this.accountId)?.users || [];
        const users = companyUsers?.filter((u) => branchUsers.find((b) => b.userId === u.id)) || [];
        if(users && users.length > 0){
          this.noRecordFound =false;
        }
        else{
          this.noRecordFound =true;
        }
        const parsedUsers = this.parseName(users);
        this.users = parsedUsers;
        this.userList = parsedUsers;
        this.usersDataSource.data = this.users;
        this.usersDataSource.data.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );
        this.usersDataSource.paginator = this.paginator;
        this.usersDataSource.sort = this.sort;
        this.usersDataSource.sortingDataAccessor = tableHelpers.sortingDataAccessor;
      })
    }

  isBranchAdmin(user){
    return this.branch?.branchAdmins.includes(user.id);
  }

  isEqual(value1 : string, value2: string) : boolean{
    if(!value1 || !value2) return false;
    return value1.toLocaleLowerCase() === value2.toLocaleLowerCase();
  }

  private navigateToCompanyOverview(): void {
    this.router.navigate(['/company',  this.companyId], { queryParams: { index: 1 } });
  }

  public getSelectableRows(): Profile[] {
    return this.currentPageUsers?.filter(
      (row) => (row.branchAssignments?.length !== 1)
    ) || [];
  }
}
